
import Title from '~/components/common/page-title.vue'

export default {
  name: 'NewsKv',
  components: {
    Title
  },
  props: {
    tag: {
      type: String,
      default: 'h1'
    }
  }
}
